import React, { useEffect, useRef, useState } from 'react';
import getUserProfile from './Avatar';

const NavBar = ({ pageIndex, setPageIndex, onLogout }) => {
  const [underlineStyle, setUnderlineStyle] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navRef = useRef(null);

  const idToken = JSON.parse(localStorage.getItem('okta-token-storage'))?.idToken;
  const claims = idToken?.claims || {};
  const email = claims?.email || '';
  
  // Name cleanup
  let rawName = claims?.name || 'User';
  const { trimmedName, avatar } = getUserProfile(rawName);

  const picture = claims?.picture || avatar;

  useEffect(() => {
    const active = navRef.current?.querySelector('.active');
    if (active) {
      setUnderlineStyle({
        width: active.offsetWidth,
        left: active.offsetLeft,
      });
    }
  }, [pageIndex]);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 50 }}>
      <nav className="bg-blue-500 text-white shadow-md">
        <div className="max-w-7xl mx-auto px-4">
          <div className="relative flex justify-between items-center h-12" ref={navRef}>
            
            {/* Centered Tabs */}
            <div className="absolute left-1/2 transform -translate-x-1/2 flex space-x-8 items-center">
              <div
                className="absolute bottom-0 h-1 bg-white transition-all duration-300"
                style={underlineStyle}
              />
              <button
                onClick={() => setPageIndex('p1')}
                className={`px-3 py-2 font-semibold ${pageIndex === 'p1' ? 'active' : ''}`}
              >
                QueryTool
              </button>
              <button
                onClick={() => setPageIndex('p2')}
                className={`px-3 py-2 font-semibold ${pageIndex === 'p2' ? 'active' : ''}`}
              >
                Upload to DB
              </button>
              <button
                onClick={() => setPageIndex('p3')}
                className={`px-3 py-2 font-semibold ${pageIndex === 'p3' ? 'active' : ''}`}
              >
                Doc Repository
              </button>
            </div>

            {/* Right-Aligned Profile */}
            <div className="flex items-center space-x-2 ml-auto">
              <div className="hidden sm:block text-right max-w-[180px] truncate">
                <div className="text-sm font-bold truncate">{trimmedName}</div>
                <div className="text-xs truncate">{email}</div>
              </div>
              <div className="relative">
                <img
                  src={picture}
                  alt="User"
                  onClick={toggleDropdown}
                  className="w-9 h-9 rounded-full cursor-pointer border-2 border-white"
                />
                {dropdownOpen && (
                  <div className="absolute right-0 top-11 w-40 bg-white text-black rounded shadow-lg z-50">
                    <button
                      className="w-full text-left px-4 py-2 hover:bg-gray-100"
                      onClick={onLogout}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
